import React, { Fragment, useEffect, useState, useContext} from "react";
import mixpanel from "mixpanel-browser";
import { RestHelper } from "../helper/restHelper";
import { UserContext } from "../app"


const OrigNewCurrent = () => {

    const {userProfile, setUser } = useContext(UserContext)
    const [request, setRequest] = useState({
        apptName:"",
        apptDate:"",
        apptTime:"",
        apptTimeTBD: false,
        apptTimeZone: 'CT',
        apptStreet:"",
        apptCity:"",
        apptState:"",
        apptZip:"",
        apptOffer:"",
        email:"",
        comments:"",
        apptLender:"",
        userProfile:"",
        contactName:"",
        contactPhone1:"",
        contactPhone2:"",
        contactEmail1:"",
        contactEmail2:"",
        fileNumber:"",
        scanBack: false,
        transactionType:"",
        financeType:""
    })
    const [profileLoaded, setProfileLoaded] = useState(false)
    const [editFlag, setEditFlag] = useState(true)
    const [errorMessage, setErrorMessage] = useState(false)
    const [showForm, setShowForm] = useState(true)
    const [apiMessage, setApiMessage] = useState('')
    const [apiDetails, setApiDetails] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [requireTime, setRequireTime] = useState(true)

    // Get today's date in YYYY-MM-DD format for date input min attribute
    const getTodayDate = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    }

    const api = RestHelper()

    const onChangeEvent = (evt) => {
        const value = evt.target.value;
        setRequest({
            ...request,
            [evt.target.id]: value
        })
    }

    useEffect(() => {
        mixpanel.track('Escrow Create New', {'action' : 'pageview'})
    }, [,])
    
    useEffect(() => {
        setRequest({
            ...request,
            ['userProfile']: userProfile.profileEmail,
            ['email'] : userProfile.profileEmail
        })
        const idArray = ['apptState']
        const stateArray = ['State', 'AK', 'AL', 'AR', 'AZ', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'HI', 
        'IA', 'ID', 'IL', 'IN', 'KS', 'KY', 'LA', 'MA', 'MD', 'ME', 'MI', 'MN', 'MO', 'MS', 'MT', 'NC', 
        'ND', 'NE', 'NH', 'NJ', 'NM', 'NV', 'NY', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 
        'UT', 'VA', 'VT', 'WA', 'WI', 'WV', 'WY']
        idArray.forEach(value => {
            const stateVar = document.getElementById(value)
            stateArray.forEach(value2 => {
                const option = document.createElement('option')
                option.innerHTML = value2
                stateVar.appendChild(option)
            })
        })
    },[profileLoaded,setProfileLoaded]);
    //const stateVar = document.getElementById('certifiedState1Select')
    
    const clearErrorMessage = () => {
        setErrorMessage(false)
        setShowForm(true)
        setRequireTime(true)
        setProfileLoaded(!profileLoaded)
        setRequest({
            ...request,
            ['apptName'] : '',
            ['apptDate'] : '',
            ['apptTime'] : '',
            ['apptTimeTBD'] : false,
            ['apptTimeZone'] : 'CT',
            ['apptStreet'] : '',
            ['apptCity'] : '',
            ['apptState'] : '',
            ['apptZip'] : '',
            ['apptOffer'] : '',
            ['email'] : '',
            ['comments'] : '',
            ['apptLender'] : '',
            ['contactName'] : '',
            ['contactPhone1'] : '',
            ['contactPhone2'] : '',
            ['contactEmail1'] : '',
            ['contactEmail2'] : '',
            ['fileNumber'] : '',
            ['scanBack']: false,
            ['transactionType']: '',
            ['financeType']:''
        })
    }

    const updateTimeField = () => {

        if(requireTime){
          setRequireTime(false)
          setRequest({
            ...request,
            ['apptTime']: '00:00',
            ['apptTimeTBD'] : true
        })
        }
        else{
          setRequireTime(true)
          setRequest({
            ...request,
            ['apptTime']: '',
            ['apptTimeTBD'] : false
        })
        }
      }

    const addState = (evt) => {
        const value = evt.target.id
        setRequest({
            ...request,
            [value] : evt.target.value
        })
    }

    const setApiRes = (res) => {
        setErrorMessage(true)
        setShowForm(false)
        setIsLoading(false)
        mixpanel.track('Escrow Create New', {'action' : 'order created'})
        setApiDetails(res['details'])
        setApiMessage(res['returnMessage'])
    }
    
   
    const callApi = () => {
        const options = {}
        setIsLoading(true)
        setShowForm(false)
        api
        .postCreate('/create-appointment-new', options, JSON.stringify(request))
        .then(res => setApiRes(res))
        .catch(err => setApiRes(err))
    }

    const convertToDate = (updatedTime) => {
        const date = new Date(updatedTime*1000)
        return date
    }

    const onSubmitHandler = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        // If editFlag is true, the preview button was selected and the updated form values are ready for review
        if ( editFlag ){
            setEditFlag(false)
        }
        // If editFlag was false, the form was in a preview mode and ready to be submitted
        else {
            callApi()
            setEditFlag(true)
        }
    }

    return (
        <Fragment>
            {errorMessage && (
                <div className="card-section">
                    <div className='card-section-header flex items-center justify-between'>
                        <div>
                            <h2 className="card-section-title">Appointment Status</h2>
                            <div className="card-section-title-bar"></div>
                        </div>
                        <button className="text-neutral-400 hover:text-neutral-600 text-2xl font-light" aria-label="Close" onClick={() =>clearErrorMessage()}>
                            &times;
                        </button>
                    </div>
                    <div className="card-section-body">
                        <div className="p-4 bg-green-50 border border-green-200 rounded-lg">
                            <p className='text-neutral-700 mb-2'>{ apiMessage }</p>
                            <p className='text-lg font-medium text-neutral-800'>{ apiDetails }</p>
                        </div>
                    </div>
                </div>
            )}
            {showForm && (
            <div className="card-section mt-4" id="myInput">
                <div className='card-section-header'>
                    <h2 className="card-section-title">Create New Event</h2>
                    <div className="card-section-title-bar"></div>
                </div>
            <div className="card-section-body">
            <form onSubmit={(e)=>onSubmitHandler(e)} className="needs-validation">
             <div className="bg-neutral-50 rounded-xl border border-neutral-200 p-4 sm:p-5 mb-6">
              <h3 className="text-lg font-semibold text-neutral-800 mb-4 pb-2 border-b border-neutral-100">Event Details <span className="text-sm font-normal text-neutral-500">(* required field)</span></h3>
              <div className="mb-4">
               <label htmlFor="apptName" className='block text-sm font-medium text-neutral-700 mb-1'>Appointment Name *</label>
               {editFlag
                ? <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500' id="apptName" onChange={(e)=>onChangeEvent(e)} type="text" value={request.apptName} required />
                : <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg bg-neutral-100' id="apptName" onChange={(e)=>onChangeEvent(e)} type="text" value={request.apptName} required readOnly/>}
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4 mb-4">
               <div>
                <label htmlFor="apptDate" className='block text-sm font-medium text-neutral-700 mb-1'>Date *</label>
                {editFlag
                ? <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500' id="apptDate" onChange={(e)=>onChangeEvent(e)} type="date" value={request.apptDate} min={getTodayDate()} required/>
                : <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg bg-neutral-100' id="apptDate" onChange={(e)=>onChangeEvent(e)} type="date" value={request.apptDate} required readOnly/>}
               </div>
               <div className="flex items-center gap-2 pt-6">
                    {editFlag
                    ? <input className="h-4 w-4 text-blue-600 border-neutral-300 rounded focus:ring-blue-500" type="checkbox" value="" id="flexCheckDefault" onChange={() => {updateTimeField()}}/>
                    : <input className="h-4 w-4 text-blue-600 border-neutral-300 rounded focus:ring-blue-500" type="checkbox" value="" id="flexCheckDefault" disabled/>}
                    <label className="text-sm font-medium text-neutral-700">Time TBD</label>
                </div>
               <div>
                {requireTime
                ?(<div><label htmlFor="apptTime" className='block text-sm font-medium text-neutral-700 mb-1'>Time *</label>
                {editFlag
                ? <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500' id="apptTime" onChange={(e)=>onChangeEvent(e)} type="time" value={request.apptTime} required/>
                : <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg bg-neutral-100' id="apptTime" onChange={(e)=>onChangeEvent(e)} type="time" value={request.apptTime} required readOnly/>}</div>)
                : <div><label htmlFor="apptTime" className='block text-sm font-medium text-neutral-700 mb-1'>Time *</label><input className='w-full px-3 py-2 border border-neutral-300 rounded-lg bg-neutral-100' id='apptTimeTBD' value='TBD' readOnly/></div>}
               </div>
               <div>
                <label htmlFor="apptTimeZone" className='block text-sm font-medium text-neutral-700 mb-1'>Timezone</label>
                {editFlag
                ? <select className='w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500' aria-label='form-select-sm' id="apptTimeZone" onChange={(e)=>onChangeEvent(e)}>
                  <option value='ET'>Eastern</option>
                    <option value='CT' selected>Central</option>
                    <option value='MT'>Mountain</option>
                    <option value='PT'>Pacific</option>
                    <option value = 'HT'>Hawaii</option>
                    <option value = 'AK'>Alaska</option>
                  </select>
                : <select className='w-full px-3 py-2 border border-neutral-300 rounded-lg bg-neutral-100' aria-label='form-select-sm' id="apptTimeZone" onChange={(e)=>onChangeEvent(e)} disabled>
                    <option value='ET'>Eastern</option>
                    <option value='CT' selected>Central</option>
                    <option value='MT'>Mountain</option>
                    <option value='PT'>Pacific</option>
                    <option value = 'HT'>Hawaii</option>
                    <option value = 'AK'>Alaska</option>
                 </select>}
                </div>
              </div>
              <div className="mb-4">
                <label htmlFor="apptStreet" className='block text-sm font-medium text-neutral-700 mb-1'>Location of Appointment *</label>
                {editFlag
                ? <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500' id="apptStreet" onChange={(e)=>onChangeEvent(e)} type="text" value={request.apptStreet} required />
                : <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg bg-neutral-100' id="apptStreet" onChange={(e)=>onChangeEvent(e)} type="text" value={request.apptStreet} required readOnly/>}
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mb-4">
               <div>
                <label htmlFor="apptCity" className='block text-sm font-medium text-neutral-700 mb-1'>City *</label>
                {editFlag
                ? <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500' id="apptCity" onChange={(e)=>onChangeEvent(e)} type="text" value={request.apptCity} required/>
                : <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg bg-neutral-100' id="apptCity" onChange={(e)=>onChangeEvent(e)} type="text" value={request.apptCity} required readOnly/>}
               </div>
               <div>
               <label htmlFor="apptState" className='block text-sm font-medium text-neutral-700 mb-1'>State *</label>
                  {editFlag
                  ? <select className='w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500' aria-label='form-select-sm' id="apptState" onChange={(e)=>addState(e)}></select>
                  : <select className='w-full px-3 py-2 border border-neutral-300 rounded-lg bg-neutral-100' aria-label='form-select-sm' id="apptState" onChange={(e)=>addState(e)} disabled></select>}
               </div>
               <div>
                <label htmlFor="apptZip" className='block text-sm font-medium text-neutral-700 mb-1'>Zip Code *</label>
                {editFlag
                ? <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500' id="apptZip" maxLength="5" onChange={(e)=>onChangeEvent(e)} type="tel" value={request.apptZip} required/>
                : <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg bg-neutral-100' id="apptZip" onChange={(e)=>onChangeEvent(e)} type="tel" value={request.apptZip} required readOnly/>}
               </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
               <div>
                <label htmlFor="fileNumber" className='block text-sm font-medium text-neutral-700 mb-1'>File Number</label>
                {editFlag
                ? <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500' id="fileNumber" onChange={(e)=>onChangeEvent(e)} type="text" value={request.fileNumber} />
                : <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg bg-neutral-100' id="fileNumber" onChange={(e)=>onChangeEvent(e)} type="text" value={request.fileNumber} readOnly/>}
               </div>
               <div>
                <label htmlFor="apptLender" className='block text-sm font-medium text-neutral-700 mb-1'>Lender</label>
                {editFlag
                ? <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500' id="apptLender" onChange={(e)=>onChangeEvent(e)} type="text" value={request.apptLender} />
                : <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg bg-neutral-100' id="apptLender" onChange={(e)=>onChangeEvent(e)} type="text" value={request.apptLender} readOnly/>}
               </div>
               </div>
               <div className="border-t border-neutral-200 pt-4 mt-4">
                <p className="text-sm font-medium text-neutral-700 mb-3">SCAN BACK REQUIRED:</p>
                <div className="flex flex-wrap gap-4">
                    <label className="flex items-center gap-2 cursor-pointer">
                        {editFlag
                        ?   <input className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500" type="radio" name="scanBack" id="scanBack" onChange={(e)=>onChangeEvent(e)} value={true} required/>
                        :   <input className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500" type="radio" name="scanBack" id="scanBack" onChange={(e)=>onChangeEvent(e)} value={true} disabled/>}
                        <span className="text-sm text-neutral-700">Required</span>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer">
                        {editFlag
                        ?   <input className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500" type="radio" name="scanBack" id="scanBack" onChange={(e)=>onChangeEvent(e)} value={false} required/>
                        :   <input className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500" type="radio" name="scanBack" id="scanBack" onChange={(e)=>onChangeEvent(e)} value={false} disabled/>}
                        <span className="text-sm text-neutral-700">Not Required</span>
                    </label>
                </div>
              </div>

              <div className="border-t border-neutral-200 pt-4 mt-4">
                <p className="text-sm font-medium text-neutral-700 mb-3">TYPE OF TRANSACTION:</p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <label className="flex items-center gap-2 cursor-pointer">
                        {editFlag
                        ?   <input className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500" type="radio" name="transactionType" id="transactionType" onChange={(e)=>onChangeEvent(e)} value={'1'} required/>
                        :   <input className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500" type="radio" name="transactionType" id="transactionType" onChange={(e)=>onChangeEvent(e)} value={'1'} disabled/>}
                        <span className="text-sm text-neutral-700">Purchase (Buyer Side)</span>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer">
                        {editFlag
                        ?   <input className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500" type="radio" name="transactionType" id="transactionType" onChange={(e)=>onChangeEvent(e)} value={'2'} required/>
                        :   <input className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500" type="radio" name="transactionType" id="transactionType" onChange={(e)=>onChangeEvent(e)} value={'2'} disabled/>}
                        <span className="text-sm text-neutral-700">Refinance</span>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer">
                        {editFlag
                        ?   <input className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500" type="radio" name="transactionType" id="transactionType" onChange={(e)=>onChangeEvent(e)} value={'3'} required/>
                        :   <input className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500" type="radio" name="transactionType" id="transactionType" onChange={(e)=>onChangeEvent(e)} value={'3'} disabled/>}
                        <span className="text-sm text-neutral-700">Seller Side Closing</span>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer">
                        {editFlag
                        ?   <input className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500" type="radio" name="transactionType" id="transactionType" onChange={(e)=>onChangeEvent(e)} value={'4'} required/>
                        :   <input className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500" type="radio" name="transactionType" id="transactionType" onChange={(e)=>onChangeEvent(e)} value={'4'} disabled/>}
                        <span className="text-sm text-neutral-700">Other (Warranty deed, single document, etc.)</span>
                    </label>
                </div>
              </div>

              <div className="border-t border-neutral-200 pt-4 mt-4">
                <p className="text-sm font-medium text-neutral-700 mb-3">TYPE OF FINANCING: <span className="font-normal text-neutral-500">(Optional)</span></p>
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
                    <label className="flex items-center gap-2 cursor-pointer">
                        {editFlag
                        ?   <input className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500" type="radio" name="financeType" id="financeType" onChange={(e)=>onChangeEvent(e)} value={'11'} />
                        :   <input className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500" type="radio" name="financeType" id="financeType" onChange={(e)=>onChangeEvent(e)} value={'11'} disabled/>}
                        <span className="text-sm text-neutral-700">FHA</span>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer">
                        {editFlag
                        ?   <input className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500" type="radio" name="financeType" id="financeType" onChange={(e)=>onChangeEvent(e)} value={'16'} />
                        :   <input className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500" type="radio" name="financeType" id="financeType" onChange={(e)=>onChangeEvent(e)} value={'16'} disabled/>}
                        <span className="text-sm text-neutral-700">VA</span>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer">
                        {editFlag
                        ?   <input className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500" type="radio" name="financeType" id="financeType" onChange={(e)=>onChangeEvent(e)} value={'12'} />
                        :   <input className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500" type="radio" name="financeType" id="financeType" onChange={(e)=>onChangeEvent(e)} value={'12'} disabled/>}
                        <span className="text-sm text-neutral-700">Conventional</span>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer">
                        {editFlag
                        ?   <input className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500" type="radio" name="financeType" id="financeType" onChange={(e)=>onChangeEvent(e)} value={'13'} />
                        :   <input className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500" type="radio" name="financeType" id="financeType" onChange={(e)=>onChangeEvent(e)} value={'13'} disabled/>}
                        <span className="text-sm text-neutral-700">Reverse</span>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer">
                        {editFlag
                        ?   <input className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500" type="radio" name="financeType" id="financeType" onChange={(e)=>onChangeEvent(e)} value={'14'} />
                        :   <input className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500" type="radio" name="financeType" id="financeType" onChange={(e)=>onChangeEvent(e)} value={'14'} disabled/>}
                        <span className="text-sm text-neutral-700">HELOC</span>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer">
                        {editFlag
                        ?   <input className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500" type="radio" name="financeType" id="financeType" onChange={(e)=>onChangeEvent(e)} value={'15'} />
                        :   <input className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500" type="radio" name="financeType" id="financeType" onChange={(e)=>onChangeEvent(e)} value={'15'} disabled/>}
                        <span className="text-sm text-neutral-700">Commercial</span>
                    </label>
                </div>
              </div>
              <div className="border-t border-neutral-200 pt-4 mt-4 mb-4">
               <label htmlFor="comments" className='block text-sm font-medium text-neutral-700 mb-1'>Additional Comments <span className="font-normal text-neutral-500">(max 400 characters)</span></label>
               {editFlag
               ? <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500' id="comments" maxLength='400' onChange={(e)=>onChangeEvent(e)} type="text" value={request.comments} />
               : <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg bg-neutral-100' id="comments" maxLength='400' onChange={(e)=>onChangeEvent(e)} type="text" value={request.comments} readOnly/>}
              </div>
              <div className="mb-4">
               <label htmlFor="email" className='block text-sm font-medium text-neutral-700 mb-1'>Title Company Email Address</label>
               {editFlag
               ? <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500' id="email" onChange={(e)=>onChangeEvent(e)} type="email" value={request.email} />
               : <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg bg-neutral-100' id="email" onChange={(e)=>onChangeEvent(e)} type="email" value={request.email} readOnly/>}
              </div>
              <div className="mb-4">
               <label htmlFor="contactName" className='block text-sm font-medium text-neutral-700 mb-1'>Signer Contact Name</label>
               {editFlag
               ? <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500' id="contactName" onChange={(e)=>onChangeEvent(e)} type="text" value={request.contactName} />
               : <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg bg-neutral-100' id="contactName" onChange={(e)=>onChangeEvent(e)} type="text" value={request.contactName} readOnly/>}
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
               <div>
                <label htmlFor="contactPhone1" className='block text-sm font-medium text-neutral-700 mb-1'>Signer Contact Phone 1</label>
                {editFlag
                ? <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500' id="contactPhone1" onChange={(e)=>onChangeEvent(e)} type="tel" value={request.contactPhone1} />
                : <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg bg-neutral-100' id="contactPhone1" onChange={(e)=>onChangeEvent(e)} type="tel" value={request.contactPhone1} readOnly/>}
               </div>
               <div>
                <label htmlFor="contactPhone2" className='block text-sm font-medium text-neutral-700 mb-1'>Signer Contact Phone 2</label>
                {editFlag
                ? <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500' id="contactPhone2" onChange={(e)=>onChangeEvent(e)} type="tel" value={request.contactPhone2} />
                : <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg bg-neutral-100' id="contactPhone2" onChange={(e)=>onChangeEvent(e)} type="tel" value={request.contactPhone2} readOnly/>}
               </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
               <div>
                <label htmlFor="contactEmail1" className='block text-sm font-medium text-neutral-700 mb-1'>Signer Email Address 1</label>
                {editFlag
                ? <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500' id="contactEmail1" onChange={(e)=>onChangeEvent(e)} type="email" value={request.contactEmail1} />
                : <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg bg-neutral-100' id="contactEmail1" onChange={(e)=>onChangeEvent(e)} type="email" value={request.contactEmail1} readOnly/>}
               </div>
               <div>
                <label htmlFor="contactEmail2" className='block text-sm font-medium text-neutral-700 mb-1'>Signer Email Address 2</label>
                {editFlag
                ? <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500' id="contactEmail2" onChange={(e)=>onChangeEvent(e)} type="email" value={request.contactEmail2} />
                : <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg bg-neutral-100' id="contactEmail2" onChange={(e)=>onChangeEvent(e)} type="email" value={request.contactEmail2} readOnly/>}
               </div>
              </div>
              </div>

             {editFlag
             ? (<div className='mt-6'><input className='bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-lg transition-colors cursor-pointer' type="submit" value="Preview"/></div>)
             : <div className='mt-6 flex gap-3'>
                 <input className='bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-6 rounded-lg transition-colors cursor-pointer' type="submit" value="Submit"/>
                 <button className='bg-neutral-200 hover:bg-neutral-300 text-neutral-800 font-medium py-2 px-6 rounded-lg transition-colors' onClick={() => setEditFlag(true)}>Edit</button>
               </div>
             }
            </form>
            </div>
            </div>
            )}
            {isLoading &&
                (<div className="bg-white rounded-xl shadow-md p-8 border border-neutral-200 mt-4">
                    <div className="flex flex-col items-center justify-center">
                        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600"></div>
                    </div>
                </div>)}
        </Fragment>
    )
   };

export default OrigNewCurrent;